const market = Object.freeze({
  name: '',
  our_phone: '',
  our_address: '',
  alt_phone: '',
  alt_address: '',
  timezone: ''
})
export default market
